import React, { Component } from 'react'
import cls from 'classnames'
import style from './style.module.less'

export default class extends Component {
  render() {
    const {
      title,
      extra,
      action,
      children,
      className = '',
      style: panelStyle,
      contentStyle = {},
      actionStyle = {},
      headerStyle = {},
      extraStyle = {}
    } = this.props
    const newClassName = cls({
      [style.panel]: true,
      [className]: className
    })
    return (
      <div className={newClassName} style={panelStyle}>
        <div className={style.header} style={headerStyle}>
          <div className={style.title}>{title}</div>

          {extra && (
            <div className={style.extra} style={extraStyle}>
              {extra}
            </div>
          )}

          {action && (
            <div className={style.action} style={actionStyle}>
              {action}
            </div>
          )}
        </div>

        <div className={cls(style.content, 'clearfix')} style={contentStyle}>
          {children}
        </div>
      </div>
    )
  }
}
